// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-__slug-indexstyleGrid-container-baufr{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.pages-info-__slug-indexstyleGrid-grid-bvcnk{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.pages-info-__slug-indexstyleGrid-col6-bcxqp{grid-column:span 6}.pages-info-__slug-indexstyleGrid-col3-ckiti{grid-column:span 3}.pages-info-__slug-indexstyleGrid-col4-biowl{grid-column:span 4}.pages-info-__slug-indexstyleGrid-col9-bxdjy{grid-column:span 9}.pages-info-__slug-indexstyleGrid-col12-xjurs{grid-column:span 12}.pages-info-__slug-indexstyleGrid-alignItemsStart-mzxrh{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "pages-info-__slug-indexstyleGrid-container-baufr",
	"grid": "pages-info-__slug-indexstyleGrid-grid-bvcnk",
	"col6": "pages-info-__slug-indexstyleGrid-col6-bcxqp",
	"col3": "pages-info-__slug-indexstyleGrid-col3-ckiti",
	"col4": "pages-info-__slug-indexstyleGrid-col4-biowl",
	"col9": "pages-info-__slug-indexstyleGrid-col9-bxdjy",
	"col12": "pages-info-__slug-indexstyleGrid-col12-xjurs",
	"alignItemsStart": "pages-info-__slug-indexstyleGrid-alignItemsStart-mzxrh"
};
module.exports = ___CSS_LOADER_EXPORT___;
